
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[totalAlias]/books",
      function () {
        return require("private-next-pages/search/[totalAlias]/books/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[totalAlias]/books"])
      });
    }
  